/**
 * KAN-834: экран приложения менеджера без вкладок (вход, просроченная ссылка):
 * содержимое по центру с отступами под вырез экрана.
 */
import type { ReactNode } from 'react';

export function MobileScreen({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 pb-[calc(1.5rem+env(safe-area-inset-bottom))] pt-[calc(1.5rem+env(safe-area-inset-top))]">
      <div className="w-full max-w-sm text-center">
        <p className="mb-6 text-2xl font-bold text-blue-600">Сметчик</p>
        {children}
      </div>
    </div>
  );
}
